/**
 * UI-only transcript part that records the tappable reply chips the customer
 * was shown under a question. `convertToModelMessages` strips `data-*` parts, so
 * these never reach the model — they exist so the admin cancel-chat transcript
 * can show the same suggestions the customer saw.
 *
 * Keep the type string in sync with `src/lib/cancel-chat-admin/reply-options.ts`.
 */

export const REPLY_OPTIONS_PART_TYPE = "data-reply-options" as const;

export type ReplyOptionsPart = {
  type: typeof REPLY_OPTIONS_PART_TYPE;
  id: string;
  data: { options: string[] };
};

export function createReplyOptionsPart(options: string[]): ReplyOptionsPart {
  return {
    type: REPLY_OPTIONS_PART_TYPE,
    id: `reply-opts-${Math.random().toString(36).slice(2, 10)}`,
    data: { options: options.filter((o) => o.trim().length > 0) },
  };
}

export function messageHasReplyOptions(parts: readonly { type?: string }[]): boolean {
  return parts.some((p) => p.type === REPLY_OPTIONS_PART_TYPE);
}
